// @ts-nocheck
/* eslint @typescript-eslint/no-explicit-any: 0 */
export function initScript(
  id: any,
  argumentF: any,
  t: any,
  ws: any,
  ms_tr_il_08: any,
  ms_tr_il_w_01: any,
) {
  const tr = function (cb?: any) {
    let count = 0
    const callback = function () {
      if (count === 0) {
        count++
        if (w) {
          w.w(id, t, cb)
        }
      }
    }

    const ts = document.createElement('script')
    ts.src = ws
    ts.type = 'text/javascript'
    ts.onload = callback
    // @ts-ignore
    ts.onreadystatechange = function () {
      // @ts-ignore
      if (this.readyState === 'complete' || this.readyState === 'loaded') {
        callback()
      }
    }
    const head = document.getElementsByTagName('head')[0]
    head.appendChild(ts)
  }
  if (typeof ms_tr_il_08 === 'function') {
    if (ms_tr_il_w_01 === null) {
      tr(function () {
        ms_tr_il_08(id, argumentF, t)
      })
    } else {
      ms_tr_il_w_01.w(
        id,
        t,
        function (websiteVisitedParams: any) {
          ms_tr_il_08(id, argumentF, t, websiteVisitedParams)
        },
        null,
      )
    }
  } else {
    tr()
  }
}
